import DataStore from 'flux/stores/DataStore.js'
import { Link } from 'react-router-dom';
var Waypoint = require('react-waypoint');
import ReactGA from 'react-ga';


class Guesthouse extends React.Component {
  constructor () {
    super()
    ReactGA.pageview(window.location.pathname + window.location.search);


    const languages = DataStore.getAllLanguages()

    const split = window.location.pathname.split('/')

    let lang = 'sv'
    if (languages.includes(split[1])) {
      lang = split[1]
    }

    let pageData = DataStore.getPageBySlug(split[split.length - 1], lang);

    const template =  pageData.template.replace('.php', '') 
    const cat = template === 'bageri' ? 'bageri' : 'logi'
    const galleryData = DataStore.getPageBySlug('galleri', 'sv');

    let galleryImages = galleryData.acf.images.map(function (element, i) {
      if (element.category.includes(cat) && element.image) {
        return element.image.sizes.square
      }
    });
    galleryImages = galleryImages.filter(function(n){ return n != undefined }); 
    if (galleryImages.length > 9) galleryImages.length = 9

    let galleryLink = undefined

    if (pageData.acf.galleryLink) {
      galleryLink = DataStore.getPageById(pageData.acf.galleryLink.ID, lang)
      galleryLink = lang === 'sv' ? galleryLink.slug : `/${lang}/${galleryLink.slug}`
    }

    this.state = {
      template: template,
      lang: lang,
      headerImage: pageData.acf.headerImage ? pageData.acf.headerImage.sizes.header : undefined,
      title: pageData.acf.title ? pageData.acf.title : pageData.title.rendered.replace('&#038;', '&'),
      content: pageData.acf.contentRepeater,
      priceColumns: pageData.acf.priceColumns,
      splash: pageData.acf.splash,
      sortimentTitle: pageData.acf.sortimentTitle,
      sortimentPdf: pageData.acf.sortimentPdf,
      contentBlocks: pageData.acf.contentBlocks,
      galleryImages: galleryImages,
      galleryLink: galleryLink
    }
  }

  render() {
    return ( 
      <div className={`page page--${this.state.template}`}>
        <div className="page__header" style={{ backgroundImage: `url(${this.state.headerImage})` }}>
          <h1 className="page__header__title">{ this.state.title }</h1>
        </div>

        <div className="page__content">

          { this.state.content &&
            this.state.content.map((item, index) => <PageContent key={`content`+index} wysiwyg={item.wysiwyg} image={item.image} />)} 
        </div>

        { this.state.priceColumns &&
          <div className="page__column__container">
            <div className="page__column__container__wrap">
              { this.state.priceColumns &&
                this.state.priceColumns[0].columnOne.map((item) => <ColumnBlock key="column1" title={item.title} content={item.content}/>)
              }

              { this.state.splash &&
                this.state.splash.map((item) => <ColumnSplash key="columnsplash" title={item.title} pagelink={item.pagelink} lang={this.state.lang}/>)
              }

              { this.state.priceColumns && 
                this.state.priceColumns[0].columnTwo.map((item) => <ColumnBlock key="column2" title={item.title} content={item.content}/>)
              }
            </div>
          </div>
        }

        {
          this.state.sortimentTitle && this.state.sortimentPdf &&
          <div className="page__sortiment">
            <a className="page__sortiment__btn" href={this.state.sortimentPdf.url} target="_blank">
              {this.state.sortimentTitle}
            </a>
            <div>
              <span className="page__sortiment__ax"></span>
              <span className="page__sortiment__ax"></span>
              <span className="page__sortiment__ax"></span>
              <span className="page__sortiment__ax"></span>
              <span className="page__sortiment__ax"></span>
              <span className="page__sortiment__ax"></span>
            </div>
          </div>

        }

        <div className="page__gallery">
          <ul className="page__gallery__list">
            { this.state.galleryImages &&
              this.state.galleryImages.map((item, i) => {
                return (
                  <li key={`img${i}`}className="page__gallery__item">
                    <div className="page__gallery__wrap">
                      <img className="page__gallery__img" src={item}/>
                    </div>
                  </li>
                )
              })
            }
            <li className="page__gallery__link">
              <Link key='gallery' to={this.state.galleryLink}>
                <span className="page__gallery__link__title">
                 { this.state.lang === 'sv' && 
                  <span>Se fler bilder</span>
                 }
                 { this.state.lang === 'en' && 
                  <span>See all images</span>
                 }
                 { this.state.lang === 'fi' && 
                  <span>Katso kaikki kuvat</span>
                 }
                  
                </span>
              </Link>
            </li>
          </ul>
        </div>

      
        { this.state.contentBlocks &&
          this.state.contentBlocks.map((item) => <FeaturedBlock key="column1" item={item} lang={ this.state.lang } />)
        }

      </div>
    );
  }
}

class PageContent extends React.Component {
  render() {
    return (
      <div className="page__content__item">
        <div className="page__content__item__text">
          <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: this.props.wysiwyg }} />
        </div>
        
        { this.props.image &&
        <div className="page__content__item__image">
          <img src={this.props.image.sizes.square}/>
        </div>
        }
      </div>
    )
  }
}

class ColumnBlock extends React.Component {
  render() {
    return (
      <div className="page__column">
        <h2 className="page__column__title">{this.props.title}</h2>
        <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: this.props.content }} ></div>
      </div>
    )
  }
}

class ColumnSplash extends React.Component {
  render() {
    const page = DataStore.getPageById(this.props.pagelink.ID, this.props.lang)
    const to = this.props.lang === 'sv' ? `/${page.slug}` : `/${this.props.lang}/${page.slug}`

    return (
      <div className="page__column__splash">
        <Link
          key={page.id}
          to={to}
        >
          <h2 className="page__column__splash__title">{this.props.title}</h2>
        </Link>
      </div>
    )
  }
}

class FeaturedBlock extends React.Component {
  render() {
    let page = undefined
    let to = undefined
    if (this.props.item.pagelink) {
      page = DataStore.getPageById(this.props.item.pagelink.ID, this.props.lang)
      to = this.props.lang === 'sv' ? `/${page.slug}` : `/${this.props.lang}/${page.slug}`
    }
    return (
      <div className="page__box">
        <div className="page__box__content">
          <div className="wysiwyg">
            <h3>{this.props.item.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: this.props.item.excerpt }} />
            { page &&
              <Link
                key={page.id}
                to={to}
              >
                {this.props.item.linkTitle}
              </Link>
            }
            
          </div>
          { this.props.item.image &&
            <div className="page__box__image page__box__image--round">
              <img src={this.props.item.image.sizes.square}/>
            </div>
           }
          
        </div>
      </div>
    )
  }
}

export default Guesthouse;



// WEBPACK FOOTER //
// ./src/scripts/components/Guesthouse.js